import type { Component } from 'vue';
import BlankLayout from '@/layouts/LayoutBlank.vue';
import SignupLayout from '@/layouts/LayoutSignup.vue';
import LayoutStep from '@/layouts/LayoutStep.vue';

export type LayoutSlug = 'blank' | 'signup' | 'step';

export const layoutComponentMap: Record<LayoutSlug, Component> = {
	blank: BlankLayout,
	signup: SignupLayout,
	step: LayoutStep,
};

export const getLayoutComponent = (slug: LayoutSlug): Component => layoutComponentMap[slug];
